module.exports = __webpack_public_path__ + "static/media/seqfold-brand-small.ee932621.png";